<template>
  <div>
    <form @submit.prevent="submit()">
      <div class="mb-3">
        <SGPFormInputComponent 
            type="text" 
            :name="'grupo'"
            v-model="formulario.grupo" 
            :placeholder="'Nome'"
            data-vv-as="Nome"
            v-validate="'required|max:255'"
            :error="validationErrors.first('grupo')"
         />
      </div>

      <div class="mb-3">
        <SGPFormInputComponent 
            type="text" 
            :name="'descricao'"
            v-model="formulario.descricao" 
            :placeholder="'Descrição'"
            data-vv-as="Descrição"
            v-validate="'required|max:255'"
            :error="validationErrors.first('descricao')"
         />
      </div>

      <div class="container-botoes">
        <button class="mdn-Button mdn-Button--primary" type="submit">
          {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
        </button>
        <button class="mdn-Button mdn-Button--secondary" type="button" @click="fecharModal()">Cancelar</button>
     </div>
      
    </form>
    

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "FormularioGrupoComponent",

  props: {
    tipoFormulario: {
      type: String,
      required: false,
      default: 'salvar'
    },
    grupo: {
      type: Object,
      required: false
    },
    descricao: {
      type: Object,
      required: false
    }
  },

  data () {
    return {
      formulario: this.$props.grupo || {
        grupo: '',
        descricao: ''
      }
    }
  },
  computed: {
    ...mapGetters('grupos', ['listaDeGrupos'])
  },
  methods: {
    ...mapActions('grupos', [
      'salvarGrupo',
      'atualizarGrupo'
    ]),
     validate: function () {
          this.$validator.validateAll();
        },
     limparCampos () {
       this.formulario.grupo = '';
       this.formulario.descricao = '';
        this.$validator.reset();
     },   
    submit () {
      // invoca o vee validade para a validação dos campos
       this.$validator.validateAll().then(async (result) => {
        if (result) {
          // eslint-disable-next-line
          if(this.tipoFormulario === 'salvar') {
            const resp = await this.salvarGrupo(this.formulario);            
            if(!resp) { 
              return;
            }
          }else{
              const resp = await this.atualizarGrupo(this.formulario);
              if(!resp){
                return;
              } 
          }

          this.limparCampos();
          this.fecharModal();
          return;
        }
      });     
       
    },

    fecharModal () {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  }


}
</script>